import {
  FS_CONTEXTS_LISTED,
  FS_CONTEXT_CREATED,
  FS_DOCUMENTS_LISTED,
  FS_DOCUMENT_CREATED,
  FS_DOCUMENT_UPDATED,
  FS_CONTEXT_UPDATED,
  FS_DOCUMENT_DELETED
} from "./types";
import { selectDocument, selectContext } from "./tasklist";
import api from "../api/FS";

/**
 * Returns an action with a list of contexts returned by the server
 * @param {[Object]} contexts
 */
export const contextsListed = contexts => ({
  type: FS_CONTEXTS_LISTED,
  contexts
});

/**
 * Dispatches a listing of contexts that are accessible to the user
 */
export const listContexts = () => dispatch =>
  api.Context.list().then(list => dispatch(contextsListed(list)));

/**
 * Returns an action with a newly created context
 * @param {Object} context
 */
export const contextCreated = context => ({
  type: FS_CONTEXT_CREATED,
  context
});

/**
 * Dispatches a listing of contexts that are accessible to the user
 */
export const createContext = (context, callback) => dispatch =>
  api.Context.create(context).then(result => {
    dispatch(contextCreated(result));
    dispatch(selectContext(result.id));
    callback();
  });

/**
 * Returns an action with a list of documents returned by the server
 * @param {[Object]} documents
 * @param {String} inContext
 */
export const documentsListed = (documents, inContext) => ({
  type: FS_DOCUMENTS_LISTED,
  documents,
  inContext
});

/**
 * Dispatches a task deletion via the API using a given task identifier
 * @param {Int} identifier ID of the task which should be deleted
 */
export const listDocumentsInContext = context => dispatch =>
  api.Document.list(context).then(list =>
    dispatch(documentsListed(list, context))
  );

/**
 * Returns an action with a newly created document
 * @param {Object} document
 * @param {String} inContext
 */
export const documentCreated = (document, inContext) => ({
  type: FS_DOCUMENT_CREATED,
  document,
  inContext
});

/**
 * Dispatches a listing of contexts that are accessible to the user
 */
export const createDocument = (document, context) => dispatch =>
  api.Document.create(document, context).then(result => {
    dispatch(documentCreated(result, context));
    dispatch(selectDocument(result.id, context));
  });

/**
 * Returns an action with an updated existing document
 * @param {Object} document
 */
export const documentUpdated = document => ({
  type: FS_DOCUMENT_UPDATED,
  document
});

/**
 * Dispatches a listing of contexts that are accessible to the user
 */
export const saveDocumentWithIdentifier = (identifier, document) => dispatch =>
  api.Document.save(identifier, document).then(result =>
    dispatch(documentUpdated(result))
  );

/**
 * Returns an action with a deleted document
 * @param {Object} document
 */
export const documentDeleted = (identifier, context) => ({
  type: FS_DOCUMENT_DELETED,
  identifier,
  context
});

/**
 * Dispatches a file deletion
 */
export const deleteDocumentWithIdentifier = (identifier, context) => dispatch =>
  api.Document.deleteDocument(identifier, context).then(() =>
    dispatch(documentDeleted(identifier, context))
  );

/**
 * Returns an action with an updated existing context
 * @param {Object} context
 */
export const contextUpdated = context => ({
  type: FS_CONTEXT_UPDATED,
  context
});

/**
 * Dispatches a listing of contexts that are accessible to the user
 */
export const updateContextWithIdentifier = (identifier, context) => dispatch =>
  api.Context.save(identifier, context).then(result =>
    dispatch(contextUpdated(result))
  );



// WEBPACK FOOTER //
// ./src/actions/fs.js